import Control from 'react-leaflet-custom-control';
import LayersButton from './LayersButton';
import { ctxUser } from '@/contexts/UserContext';
import { useContext } from 'react';

export default function LayersControl() {
  const userCtx = useContext(ctxUser);
  return (
    <Control prepend position="bottomleft">
      {userCtx?.hasExtraFeature('extrafeature_pluto_goi') && <LayersButton />}
    </Control>
  );
}
